import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { calcage } from 'components/CalculateAge';
import style from './style.module.scss';
import { IMAGE_STATUS } from '../../../config/constants';
import { useQueryClient } from 'react-query';
import { useLocation } from 'react-use';

const styles = {
  card: {
    boxShadow: '0px 0px 0px 0px',
    borderRadius: 5,
  },
  media: {
    height: '265px',
    objectFit: 'cover',
  },
};

function ImgMediaCard(props) {
  const {pathname} = useLocation()

  let { card } = props;
  let { avatar } = props.card;

  const displayImage = () => {
    let imageurl = '';
    if (avatar !== null) {
      if (avatar.inspection === IMAGE_STATUS.CONFIRMED) {
        imageurl = avatar.url;
      } else {
        imageurl = pathname === '/search-agent-result' ? require('assets/image-icon/no_agent_photo.png') : require('assets/image-icon/no_user_photo.png');
      }
    } else {
      imageurl =  pathname === '/search-agent-result' ? require('assets/image-icon/no_agent_photo.png') : require('assets/image-icon/no_user_photo.png');
    }

    return imageurl;
  };

  const selectCardinCard = () => {
    return props.selectCardinGrid(card);
  };

  return (
    <Card className={props.classes.card}>
      <div className={style.div__media}>
        <CardMedia
          className={style.__media}
          component="img"
          alt=""
          image={displayImage()}
          title={card.nickName}
          onClick={() => {
            selectCardinCard();
          }}
        />
      </div>
      <CardContent className={style.cardContent}>
        <Typography component="p" color="secondary">
          <span className={style.spanName}>{card.nickName}</span>
          {card?.standBy === 1 && (
            <span
            className="font-2"
            style={{ float: 'right', marginRight: 10 }}
            >
              待機状態
            </span>
          )}
        </Typography>
        <Typography component="p">
          <span className={style.spanProvince}>
            {card.birthday
              ? card?.states?.label + ` ` + calcage(new Date(Number(new Date(parseInt(card.birthday))))) + ` 歳`
              : card?.states?.label}
          </span>
        </Typography>
      </CardContent>
    </Card>
  );
}

ImgMediaCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImgMediaCard);
